(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pd-label-viewer"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('pd-label-viewer')) return;
  class LabelViewer extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.dialog = this.querySelector('dialog');
      this.image = this.querySelector('[data-label-image]');
      this.canvas = this.querySelector('[data-label-canvas]');
      this.status = this.querySelector('[data-label-status]');
      this.zoom = this.querySelector('[data-label-zoom]');
      this.inline = this.querySelector('[data-label-inline]');
      this.closeButton = this.querySelector('[data-label-close]');
      if (!this.dialog || !this.image || !this.canvas || !this.status || !this.zoom || !this.inline || !this.closeButton) return;
      const options = { signal: this.abort.signal };
      document.addEventListener('click', (event) => {
        const link = event.target.closest?.('a[data-pd-label-src]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
        const fallback = this.fallbackFor(link);
        const source = this.sourceFor(link);
        if (!fallback || !source) return;
        event.preventDefault();
        this.trigger = link;
        this.fallback = fallback;
        if (typeof this.dialog.showModal !== 'function') {
          this.openInline();
          return;
        }
        this.open(source, link);
      }, options);
      this.closeButton.addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('pd-label-viewer-open');
        if (this.returnFocus !== false && this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
        this.returnFocus = true;
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.zoom.addEventListener('click', () => this.setZoom(this.zoom.getAttribute('aria-pressed') !== 'true'), options);
      this.inline.addEventListener('click', (event) => {
        event.preventDefault();
        this.openInline();
      }, options);
      this.image.addEventListener('load', () => {
        if (!this.dialog.open) return;
        this.image.hidden = false;
        this.status.textContent = '';
        this.zoom.disabled = false;
        this.image.style.setProperty('--pd-label-zoom-width', `${Math.max(this.image.naturalWidth, 960)}px`);
      }, options);
      this.image.addEventListener('error', () => {
        if (!this.dialog.open) return;
        this.image.hidden = true;
        this.zoom.disabled = true;
        this.status.textContent = this.dataset.error;
      }, options);
    }
    sourceFor(link) {
      try {
        const source = new URL(link.dataset.pdLabelSrc, document.baseURI);
        if (source.protocol !== 'https:' || !['cdn.shopify.com', 'cdn.sanity.io'].includes(source.hostname)) return null;
        return source.href;
      } catch { return null; }
    }
    fallbackFor(link) {
      const href = link.getAttribute('href');
      if (!href?.startsWith('#')) return null;
      return document.getElementById(href.slice(1));
    }
    open(source, link) {
      this.returnFocus = true;
      this.setZoom(false);
      this.image.hidden = true;
      this.zoom.disabled = true;
      this.status.textContent = this.dataset.loading;
      this.querySelector('[data-label-product]').textContent = link.dataset.pdLabelTitle || '';
      this.image.alt = [link.dataset.pdLabelTitle, this.dataset.imageLabel].filter(Boolean).join(' — ');
      this.inline.setAttribute('href', link.getAttribute('href'));
      try {
        if (!this.dialog.open) this.dialog.showModal();
      } catch {
        this.openInline();
        return;
      }
      document.documentElement.classList.add('pd-label-viewer-open');
      this.closeButton.focus({ preventScroll: true });
      this.image.src = source;
    }
    setZoom(zoomed) {
      this.zoom.setAttribute('aria-pressed', String(zoomed));
      this.querySelector('[data-label-zoom-in]').hidden = zoomed;
      this.querySelector('[data-label-zoom-out]').hidden = !zoomed;
      this.canvas.toggleAttribute('data-zoomed', zoomed);
      this.canvas.scrollTop = 0;
      this.canvas.scrollLeft = 0;
    }
    openInline() {
      if (this.dialog.open) {
        this.returnFocus = false;
        this.dialog.close();
      }
      if (!this.fallback) return;
      const decisions = this.fallback.closest('pd-product-decisions');
      decisions?.revealPanel?.(this.fallback);
      for (let node = this.fallback; node; node = node.parentElement) {
        if (node.tagName === 'DETAILS') node.open = true;
      }
      (this.fallback.querySelector('summary') || this.fallback).focus({ preventScroll: true });
      this.fallback.scrollIntoView({ block: 'start', behavior: 'instant' });
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.abort?.abort();
      document.documentElement.classList.remove('pd-label-viewer-open');
    }
  }
  customElements.define('pd-label-viewer', LabelViewer);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pd-motion-graphic"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pd-motion-graphic')) {
    customElements.define('pd-motion-graphic', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.motion === 'false' || !window.IntersectionObserver) return;
        this.preference = matchMedia('(prefers-reduced-motion: reduce)');
        this.onPreference = () => {
          if (this.preference.matches) {
            this.observer?.disconnect();
            this.classList.remove('is-drawing');
          }
        };
        this.preference.addEventListener('change', this.onPreference);
        if (this.preference.matches) return;
        this.querySelectorAll('.pd-motion-graphic__glyph path').forEach(path => {
          const length = path.getTotalLength();
          if (Number.isFinite(length) && length > 0) {
            path.style.setProperty('--pd-path-length', String(length));
            path.style.strokeDasharray = String(length);
          }
        });
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.classList.add('is-drawing');
            this.observer.unobserve(this);
          });
        }, {threshold:.3});
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.preference?.removeEventListener('change', this.onPreference);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pd-purchase-presentation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pd-purchase-presentation')) {
    customElements.define('pd-purchase-presentation', class extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;
        this.region = this.closest('product-info');
        if (!this.region) return;
        this.queue = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
        };
        this.observer = new MutationObserver(this.queue);
        this.observer.observe(this.region, { childList: true, subtree: true });
        this.region.addEventListener('change', this.queue);
        this.update();
      }
      text(parent, className, value) {
        if (!parent || !value) return;
        let element = parent.querySelector(`.${className}`);
        if (!element) {
          element = document.createElement('span');
          element.className = className;
          parent.append(element);
        }
        if (element.textContent !== value) element.textContent = value;
      }
      update() {
        const widget = this.region.querySelector('.appstle_subscription_wrapper');
        if (!widget) return;
        this.text(widget.querySelector('.appstle_one_time_description_text'), 'pd-v-offer-description', this.dataset.once);
        this.text(widget.querySelector('.appstle_one_time_price_wrapper'), 'pd-v-offer-unit', this.dataset.perItem);
        this.text(widget.querySelector('.appstle_subscription_description_text'), 'pd-v-offer-description', this.dataset.subscription);
        this.text(widget.querySelector('.appstle_subscription_amount_wrapper'), 'pd-v-offer-unit', this.dataset.perDelivery);
        widget.querySelectorAll('.appstle_include_dropdown').forEach(option => {
          const selected = option.querySelector('.appstle-radio-wrapper:has(input:checked) .appstleSellingPlanDescription');
          const source = selected || option.querySelector('.appstleSellingPlanDescription');
          const terms = source?.textContent.trim();
          this.text(option, 'pd-v-offer-terms', terms);
        });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.region?.removeEventListener('change', this.queue);
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.observer = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pd-purchase-reassurance"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pd-purchase-reassurance')) {
    customElements.define('pd-purchase-reassurance', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.querySelectorAll('[data-policy-target]').forEach(button => {
          const details = document.getElementById(button.dataset.policyTarget);
          if (!details) return;
          details.addEventListener('toggle', () => button.setAttribute('aria-expanded', String(details.open)));
          button.addEventListener('click', () => {
            details.open = !details.open;
            button.setAttribute('aria-expanded', String(details.open));
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pd-serving-snapshot"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pd-serving-snapshot')) {
    customElements.define('pd-serving-snapshot', class extends HTMLElement {
      connectedCallback() {
        if (!window.IntersectionObserver || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.classList.add('is-in-view');
            this.observer.disconnect();
          }
        }, {threshold:.2});
        this.observer.observe(this);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
